<viavi-table
  [tableConfigurations]="table"
  [isActionEnabled]="true"
  (sendSeletedItem)="sendSelectedItem($event)"
></viavi-table>
